export const formatDate = (date: Date): string => {
  try {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch (error) {
    return 'N/A';
  }
};

export const formatTime = (date: Date): string => {
  try {
    return new Date(date)
      .toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
      })
      .replace(' ', '');
  } catch (error) {
    return 'N/A';
  }
};

export const formatDateTime = (date: Date): string => {
  return `${formatDate(date)} ${formatTime(date)}`;
};
